module.exports = __webpack_public_path__ + "static/media/samsung_pay.ae251765.svg";